import { render } from "./Comment.vue?vue&type=template&id=6701bf96&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=6701bf96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6701bf96"

export default script